import React from 'react'
import UserContext from './../context/UserContext'
import PropTypes from 'prop-types'

function UserProvider(props) {
    const {getUsers, treeData, listDepartment, roles, tenants, extensions, getExtensions, listCalloutId} = props

    return (
        <UserContext.Provider
            value={{
                getUsers,
                treeData,
                listDepartment,
                roles,
                tenants,
                extensions,
                getExtensions,
                listCalloutId
            }}
        >
            {props.children}
        </UserContext.Provider>
    )
}

UserProvider.propTypes = {
    getUsers: PropTypes.func.isRequired,
    treeData: PropTypes.array.isRequired,
    listDepartment: PropTypes.array.isRequired,
    roles: PropTypes.array.isRequired
}

export default UserProvider